import {
  ButtonsContainer,
  TabContainer,
} from "../move-inRegistrationTabs/move-inTabs.styled";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { useState, FC, ReactElement, useEffect } from "react";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import User from "../../stores/UserStore";

interface Obj {
  [key: string]: any;
}


interface Props extends BaseProps {
  availableAccounts: Obj[];
  totalAmount: string;
  loadAvailableAccounts: () => Promise<void>;
  addAccount: (a: {}) => void;
  removeAccount: (a: string) => void;
  setacParent: any;
  setIschanged: any;
  cashRefund: (value: boolean) => void;
}

const AvailableRefund: FC<Props> = ({
  Next,
  Previous,
  totalAmount,
  availableAccounts,
  loadAvailableAccounts,
  addAccount,
  removeAccount,
  setacParent,
  setIschanged,
  cashRefund,
}: Props): ReactElement => {
  const [all, setAll] = useState<boolean>(true);
  const [acc, setac] = useState<any>([]);
  const [personIDType,setPersonIDType] = useState<any>(null)
  const [primaryId,setPrimaryId] = useState<boolean>(false)

  const handleClick = () => {
    setAll((prev) => !prev);
    setIschanged(true);
  };
  const [checkedAccount, setCheckedAccount] = useState<any>(null);

  const handleAccountToggle = (
    event: React.ChangeEvent<HTMLInputElement>,
    acId: any,
    amount: any
  ) => {
    setIschanged(true)
    if (acc.includes(acId)) {
      // If it is, remove it from the state
      setac(acc.filter((id: any) => id !== acId));
      setacParent(acc.filter((id: any) => id !== acId));
      setCheckedAccount(null);
    } else {
      // If it's not, add it to the state
      setCheckedAccount(amount)
      setac([acId]);
      setacParent([acId]);
    }
    const index = parseInt(event.target.value);
    if (event.target.checked) addAccount(availableAccounts[index]);
    else removeAccount(availableAccounts[index].accountId);
  };
  useEffect(() => {
    loadAvailableAccounts();
  
  }, []);
  useEffect(() => {
    (async () => {
      const userdata = await User.getPoboxData({
        errorId: "getBankDataError",
        data: User.info.personId,
      });
      const personId2 = userdata?.personId2 || [];
      // console.log("userdata", userdata?.personId2[0]?.idType);
      // const uniId = userdata?.personId2?.find((x: any) => x.idType === "UNI");
      // setPersonIDType(uniId?.idType || null);
      setPersonIDType(userdata?.personId2[0]?.idType);
      const hasPrimaryUNI = personId2.some(
        (item: any) => item.idType === "UNI" && item.isPrimaryId === true
      );

      setPrimaryId(hasPrimaryUNI);
    })();
  }, []);
  useEffect(() => {
    console.log("acc", personIDType);
   }, [personIDType]);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <>
      <TabContainer >
        <p
          style={{
            fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          }}
        >
          {General?.codeLabels["cm_refund_intro"]?.label !== undefined ? General?.codeLabels["cm_refund_intro"]?.label : "Here are the available accounts and the amount you are eligible to getas refund"}
        </p>
        <Table  >
          <thead>
            <tr
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: General?.isLargeScreen ? "0.5rem 0.5rem" : "",
                width: General?.isLargeScreen ? "72vw" : "100%",
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "transparent",
              }}
            >
              <th
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {/* <input
                  style={{ height: "20px", width: "20px" }}
                  checked={all}
                  type="checkbox"
                  onClick={handleClick}
                /> */}
                {General?.codeLabels["cm_accountid"]?.label !== undefined
                  ? General?.codeLabels["cm_accountid"]?.label
                  : "Account Number"}
              </th>
              <th
                style={{
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_dpremisedetails"]?.label !== undefined
                  ? General?.codeLabels["cm_dpremisedetails"]?.label
                  : "Premise Details"}
              </th>
              <th
                style={{
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_available_balance"]?.label !== undefined ? General?.codeLabels["cm_available_balance"]?.label : "Available Balance Amount"}
              </th>
            </tr>
          </thead>
          <tbody style={{}}>
            {availableAccounts ? (
              availableAccounts.map((account, index) => {
                return (
                  <tr
                    style={{
                      display: "flex",
                      width: General?.isLargeScreen ? "70vw" : "98%",
                      alignItems: "center",
                      justifyContent: "space-between",

                    }}
                  >
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: General?.isLargeScreen ? "20px" : "",
                        width: "16vw",
                        gap: "1rem",
                        fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                      }}
                    >
                      <input
                        style={{ height: "20px", width: "20px" }}
                        type="checkbox"

                        checked={
                          // all
                          //   ? all
                          //   : 
                          acc.includes(account.accountId)
                            ? true
                            : false
                        }
                        value={index}
                        onChange={(e) =>
                          handleAccountToggle(e, account.accountId, account?.accountBalance)
                        }
                      />
                      {account.accountId}
                    </td>

                    <td
                      style={{
                        width: "21vw",
                        justifyContent: "center",
                        display: "block",
                        fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                      }}
                    >
                      {account.premiseAddress}
                    </td>
                    <td
                      style={{
                        textAlign: "start",
                        width: "5vw",
                        paddingRight: "3rem",
                        fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                        direction: 'ltr'
                      }}
                    >
                      {new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(account.accountBalance)}
                    </td>
                  </tr>
                );
              })
            ) : (
              <p
                style={{
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_available_balance_no"]?.label !== undefined ? General?.codeLabels["cm_available_balance_no"]?.label : "No accounts available for Refund"}
              </p>
            )}

            <tr
              style={{
                display: "flex",
                width: General?.isLargeScreen ? "100%" : "100%",
                justifyContent: "space-between",
                padding: "0.5rem 0.5rem",
                background: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
              }}
            >
              <td
                style={{
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  fontWeight: "700",
                  fontStyle: "normal",
                  fontFamily: "Segoe UI",
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_total1"]?.label !== undefined
                  ? General?.codeLabels["cm_total1"]?.label
                  : "Total"}{" "}
                {General?.codeLabels["cm_mob_aed"]?.label !== undefined ? General?.codeLabels["cm_mob_aed"]?.label : "AED"}
              </td>
              <td></td>
              <td
                style={{
                  fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                  fontWeight: "400",
                  fontStyle: "normal",
                  fontFamily: "Segoe UI",
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  direction: 'ltr'
                }}
              >
                {new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(checkedAccount))}
              </td>
            </tr>
          </tbody>
        </Table>
        <br />
        <div style={{ width: General?.isLargeScreen ? "90%" : "100%", display: "flex", flexDirection: General?.isLargeScreen ? "row" : "column", gap: "2rem" }}>
        <ButtonSecondary
          style={{
            height: "50px",
            width: General?.isLargeScreen ? "40%" : "100%",
            fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
            fontWeight: "700",
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            background: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss,
            border: "none",
            opacity: acc?.length && checkedAccount > -5000 && primaryId ? '1' : '0.5'
          }}
          onClick={() => cashRefund(true)}
          disabled={!acc?.length || !(checkedAccount > -5000) || !primaryId}
        >
          {General?.codeLabels["cm_cashpayout"]?.label !== undefined
            ? General?.codeLabels["cm_cashpayout"]?.label
            : "CASH REFUND"}
        </ButtonSecondary>
          <ButtonSecondary
            style={{
              height: "50px",
              width: General?.isLargeScreen ? "60%" : "100%",
              fontWeight: "700",
              fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
              border: "none",
              opacity: acc?.length ? '1' : '0.5'
            }}
            disabled={acc?.length > 0 ? false : true}
            onClick={Next}
          >
            {General?.codeLabels["cm_rquest_refund"]?.label !== undefined ? General?.codeLabels["cm_rquest_refund"]?.label : "REQUEST FOR A REFUND"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              height: "50px",
              width: General?.isLargeScreen ? "70%" : "100%",
              fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
              fontWeight: "700",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
              border: "none",
              opacity: acc?.length ? '1' : '0.5'
            }}
            onClick={Previous}
            disabled={acc?.length > 0 ? false : true}
          >
            {General?.codeLabels["cm_transfer_to_other"]?.label !== undefined ? General?.codeLabels["cm_transfer_to_other"]?.label : "TRANSFER TO ANOTHER ACCOUNT"}

          </ButtonSecondary>
          
        </div>
        <div
          style={{
            marginTop: "2rem",
            maxWidth: "700px",
            background: contrast?.contrastBackground ? contrast?.contrastBackground : "transparent",
            borderRadius: "8px",
            border: `1px solid ${contrast?.contrastColor ? contrast?.contrastColor : ColorAss}`,
            opacity: 0.85,
            padding: "1rem 2rem"
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize * 1.1}rem` : `${0.8 * General.accessibility.fontSize}rem`,
              marginBottom: "0.5rem",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
          >
            {General?.codeLabels["cm_mob_info"]?.label !== undefined ? General?.codeLabels["cm_mob_info"]?.label : "Information"} 
          </div>
          <ul
            style={{
              fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              listStyleType: "disc",
              paddingLeft: "1.5rem",
              margin: 0,
            }}
          >
            <li>
              {General?.codeLabels["cm_forpayoutcollectamountafterapprove"]?.label !== undefined
              ? General?.codeLabels["cm_forpayoutcollectamountafterapprove"]?.label
              : "For cash refund please collect the refund amount from your nearest Al Ansari exchange after your request is approved."}
            </li>
            <li>
                {General?.codeLabels["cm_cashpayoutminbalance"]?.label !== undefined
                ? General?.codeLabels["cm_cashpayoutminbalance"]?.label.replace("{0}", "5000")
                : "Maximum amount permitted for Cash Payout is AED 5000"}
            </li>
          </ul>
        </div>
      </TabContainer>
    </>
  );
};

export default observer(AvailableRefund);
